import { Resource as o } from "@coveo/platform-client";
class n extends o {
  constructor(e, r, s) {
    super(e, r), this.internalAPI = s;
  }
}
export {
  n as BackendOnlyResource
};
//# sourceMappingURL=BackendOnlyResource.js.map
